<script lang="ts" setup>
import type { LayoutSlots } from '@sigma/ui/layout/Layout.jsx';
import StickyElement from '@sigma/ui/StickyElement.vue';

const slots = defineSlots<LayoutSlots>();
</script>

<template>
  <div>
    <h2
      v-if="slots.title"
      :class="css.title"
    >
      <slot name="title" />
    </h2>
    <p
      v-if="slots.subtitle"
      :class="css.subtitle"
    >
      <slot name="subtitle" />
    </p>

    <!-- Content -->
    <slot />

    <!-- Footer -->
    <StickyElement
      v-if="slots.footer"
      position="bottom"
      :class="css.footer"
      :pinned-class="css.footerSticky"
    >
      <slot name="footer" />
    </StickyElement>
  </div>
</template>

<style lang="scss" module="css">
.title {
  font-size: $font-size-20;
  font-weight: 700;
}

.subtitle {
  font-size: $font-size-16;
  font-weight: $font-weight-400;
  color: $color-gray-600;
  margin-bottom: $spacing-08;
  margin-top: $spacing-12;
}

.footer {
  display: flex;
  flex-direction: column;
  padding: $spacing-12 $spacing-24;
  margin-top: auto;
  margin-inline: -$spacing-24;
  transition: background-color 0.15s ease-out;

  @include media-min-md {
    border-radius: $border-radius-24 $border-radius-24 0 0;
    padding: $spacing-16;
    margin-inline: -$spacing-12;
    margin-top: $spacing-24;
  }
}

.footerSticky {
  background: $color-white;
}
</style>
